class Font_Constant {
	static SMALL_ICON = 10;
	static MEDIUM_ICON = 20;
	static LARGE_ICON = 25;
}
export default Font_Constant;
